import React from "react";
import "./styles.css";

const HelpIcon = ({ isActive, handleClick }) => {
  return (
    <div className="icon-container icon-margin-btm" id="invite">
      <a className="icon-anchor" onClick={handleClick}>
        <svg
          className="svg-container element-icon"
          width="100%"
          height="100%"
          viewBox="0 0 512 512"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlSpace="preserve"
          xmlnsserif="http://www.serif.com/"
        >
          <g transform="matrix(1.79021,0,0,1.79021,53.7063,19.6923)">
            <circle className={`el-circle ${isActive ? "active" : ""}`} cx="113" cy="132" r="143" />
          </g>

          <g className="el-path" transform="matrix(15.65,0,0,15.65,68.2,68.2)">
            <path
              d="M4.929,4.929C6.804,3.054 9.348,2 12,2C14.652,2 17.196,3.054 19.071,4.929C20.946,6.804 22,9.348 22,12C22,13.313 21.741,14.614 21.239,15.827C20.736,17.04 20,18.142 19.071,19.071C18.142,20 17.04,20.736 15.827,21.239C14.614,21.741 13.313,22 12,22C10.687,22 9.386,21.741 8.173,21.239C6.96,20.736 5.858,20 4.929,19.071C4,18.142 3.264,17.04 2.761,15.827C2.259,14.614 2,13.313 2,12C2,9.348 3.054,6.804 4.929,4.929ZM12,4C9.878,4 7.843,4.843 6.343,6.343C4.843,7.843 4,9.878 4,12C4,13.051 4.207,14.091 4.609,15.062C5.011,16.032 5.6,16.914 6.343,17.657C7.086,18.4 7.968,18.989 8.939,19.391C9.909,19.793 10.949,20 12,20C13.051,20 14.091,19.793 15.062,19.391C16.032,18.989 16.914,18.4 17.657,17.657C18.4,16.914 18.989,16.032 19.391,15.062C19.793,14.091 20,13.051 20,12C20,9.878 19.157,7.843 17.657,6.343C16.157,4.843 14.122,4 12,4ZM11,17C11,16.448 11.448,16 12,16L12.01,16C12.562,16 13.01,16.448 13.01,17C13.01,17.552 12.562,18 12.01,18L12,18C11.448,18 11,17.552 11,17ZM12.005,8.999C12.853,8.995 13.326,9.2 13.579,9.417C13.87,9.667 13.998,9.97 13.998,10.247C13.998,10.266 13.998,10.285 13.999,10.304C14.015,10.574 13.942,10.842 13.791,11.067C13.552,11.426 13.257,11.553 12.731,11.779C12.679,11.801 12.625,11.825 12.569,11.849C12.296,11.968 11.88,12.156 11.552,12.506C11.179,12.904 11.001,13.411 11.001,14C11.001,14.552 11.448,14.999 12,14.999C12.552,14.999 12.999,14.552 12.999,14C12.999,13.92 13.009,13.881 13.012,13.87C13.036,13.847 13.109,13.792 13.365,13.681C13.411,13.661 13.462,13.64 13.519,13.617C14.014,13.412 14.864,13.06 15.454,12.175C15.839,11.598 16.028,10.912 15.995,10.219C15.986,9.315 15.563,8.486 14.879,7.9C14.147,7.273 13.147,6.996 11.996,7.001C11.36,7.004 10.541,7.16 9.845,7.594C9.107,8.056 8.501,8.85 8.501,10C8.501,10.552 8.948,10.999 9.5,10.999C10.052,10.999 10.499,10.552 10.499,10C10.499,9.656 10.643,9.452 10.905,9.288C11.209,9.098 11.64,9 12.005,8.999Z"
            />
          </g>
        </svg>
        {!isActive && (
          <div className="tooltip">
            <p>Help</p>
            <div className="triangle"></div>
          </div>
        )}
        {isActive && <div className="triangle menu"></div>}
      </a>
    </div>
  );
};
export default HelpIcon;
